import toast from 'react-hot-toast'
import {
  XMarkIcon,
  CheckCircleIcon,
  ExclamationCircleIcon,
} from '@heroicons/react/24/outline'
import LoadingSpinner from '@tw/LoadingSpinner'

export default function ToastContent({ toastData, icon, message, className, ...rest }) {

  let shadowColor
  let fancyIcon
  if (toastData.type === 'success') {
    shadowColor = 'shadow-green-500'
    fancyIcon = <CheckCircleIcon className="w-5 h-5 text-green-700" />
  } else if (toastData.type === 'error') {
    shadowColor = 'shadow-red-500'
    fancyIcon = <ExclamationCircleIcon className="w-5 h-5 text-red-700" />
  } else if (toastData.type === 'loading') {
    shadowColor = 'shadow-amber-500'
    fancyIcon = <LoadingSpinner className="w-5 h-5 text-slate-400"/>
  } else {
    shadowColor = 'shadow-amber-500'
  }

  return (
    <div
      className={`
        !bg-transparent !bg-gradient-to-r !from-slate-300/10 !to-slate-300/10
        !rounded-xl !ring-1 !ring-white/10
        flex  items-center
        min-w-[300px]
        px-2 pt-1 pb-2

        text-white
        shadow-md
        ${shadowColor}
        ${className}
      `}
    >
      <div className="flex flex-grow pt-1 ">
        <div className="self-center flex-shrink align-middle justify-items-center">
          {fancyIcon}
        </div>
        <div className="flex-grow">
          <div className="text-sm">
            {message}
          </div>
        </div>
      </div>
      <div className="flex-shrink px-2">
        {toastData.type !== 'loading' && (
          <button
            className={`
            rounded-full
            h-6 w-6
            mt-1.5
            focus:outline-none active:outline-none
            hover:bg-gray-900
            text-gray-400 hover:text-gray-300
          `}
            onClick={() => toast.dismiss(toastData.id)}
          >
            <XMarkIcon className="inline w-full h-full p-1 align-middle place-self-center" />
          </button>
        )}
      </div>
    </div>
  )
}
